import { HybridTooltip, Icon } from '@advanza/ui'

interface Props {
    /** Replacement leads for this week, delivered ones included. */
    given: number
}

/**
 * The replacement leads this week brings on top of the week limit it sits next to. Always rendered,
 * including at 0, so CS can see the field exists at all.
 */
const ReplacementLeadBadge = ({ given }: Props) => (
    <span className="inline-flex items-center gap-1 font-bold text-secondary-600">
        +{given}
        <HybridTooltip
            className="z-[101]"
            childrenContent={
                <div className="max-w-[240px]">
                    <div className="font-bold">Replacement leads</div>
                    Approved reclaims turn into replacement leads, delivered on top of the week
                    limit. That&#39;s why the weekly total can go above the limit.
                </div>
            }>
            <span className="leading-[0]">
                <Icon name="info" fontSize={14} classNameIcon="!text-grey-700 cursor-help" />
            </span>
        </HybridTooltip>
    </span>
)

export default ReplacementLeadBadge
